/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelSubscriptionRequest } from '../models/CancelSubscriptionRequest';
import type { OrganizationInfoResource } from '../models/OrganizationInfoResource';
import type { StoreRetentionDiscountRequest } from '../models/StoreRetentionDiscountRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class OrganizationsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Cancel your subscription.
     * @returns void
     * @throws ApiError
     */
    public cancelSubscription({
        requestBody,
    }: {
        /**
         * Cancellation request
         */
        requestBody: CancelSubscriptionRequest,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/organizations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

    /**
     * Create a CancellationFeedback record for an organization
     * This is used when an organization linked to Tithely
     * request cancellation, so we can store the reason and other details.
     * @returns void
     * @throws ApiError
     */
    public createCancellationFeedbackRecord({
        reason,
        reasonFeatures,
        reasonFeaturesComment,
        comment,
        switchedTo,
        switchedToReason,
    }: {
        /**
         * Reason for cancellation
         */
        reason: string,
        /**
         * Reason for cancellation due to missing features
         */
        reasonFeatures: string,
        /**
         * Comment about cancellation due to missing features
         */
        reasonFeaturesComment: string,
        /**
         * Additional comments
         */
        comment: string,
        /**
         * ChMS switched to
         */
        switchedTo?: string,
        /**
         * Reason ChMS was switched to
         */
        switchedToReason?: string,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/organizations/cancellation',
            query: {
                'reason': reason,
                'reason_features': reasonFeatures,
                'reason_features_comment': reasonFeaturesComment,
                'comment': comment,
                'switched_to': switchedTo,
                'switched_to_reason': switchedToReason,
            },
            errors: {
                400: `Bad request`,
            },
        });
    }

    /**
     * Apply discount to an account going through cancellation process.
     * @returns void
     * @throws ApiError
     */
    public apply25DollarDiscount({
        requestBody,
    }: {
        /**
         * Store Retention Discount Request
         */
        requestBody: StoreRetentionDiscountRequest,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/organizations/discount',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

    /**
     * Get very basic organization information.
     * @returns any OK
     * @throws ApiError
     */
    public a8F92D3B95Ac2Ed2C7F3B9010334953A({
        subdomain,
    }: {
        /**
         * Subdomain used by an organization
         */
        subdomain: string,
    }): CancelablePromise<{
        data: OrganizationInfoResource;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organizations/info/{subdomain}',
            path: {
                'subdomain': subdomain,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

}
